import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import bookingActions from 'actions/bookings/actions'
import Form from './form'

const formName = 'merchant-send-proposal-form'

const SendProposal = ({ id: inquiryId, spaceId, userId, clientId, options: { spaces: spaceOptions }, fetchProposalOptions, handleClose, sendProposal, notification: { type } }) => {
  useEffect(() => { fetchProposalOptions({ id: userId }) }, [])

  return <div className={`merchant-edit-proposal`}>
    {type === 'success' && handleClose()}
    <Form
      form={formName}
      initialValues={{ space: spaceId }}
      onSubmit={values => sendProposal({ ...values, clientId, inquiryId })}
      spaceOptions={spaceOptions}
    />
  </div>
}

SendProposal.propTypes = {
  id: PropTypes.number.isRequired,
  clientId: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired,
  sendProposal: PropTypes.func.isRequired,
  fetchProposalOptions: PropTypes.func.isRequired,
  details: PropTypes.object,
  options: PropTypes.object,
  notification: PropTypes.object,
  spaceId: PropTypes.number
}

const mapStateToProps = ({ bookings, auth, notification }) => ({
  userId: auth.user.id,
  details: bookings.proposalDetails,
  options: bookings.proposalOptions,
  notification,
});

const mapDispatchToProps = {
  fetchProposalOptions: bookingActions.fetchMerchantProposalOptions,
  sendProposal: bookingActions.merchantSendProposal,
};

export default connect(mapStateToProps, mapDispatchToProps)(SendProposal)
